import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import {
  ContainerRow,
  ContainerStatistics,
  ContainerDetailsModalData,
  ContainerModalData,
} from '../interfaces/container.interface';

/**
 * Construiește query params-ii comuni: firma selectată (opțional) + direcția
 * curentă (import/export). Backend-ul acceptă `direction` opțional — dacă
 * lipsește folosește prima direcție permisă a contului, iar dacă direcția nu e
 * permisă răspunde cu 403.
 */
function dataParams(companyId?: number, direction?: ShippingDirection) {
  return {
    ...(typeof companyId === 'number' ? { companyId } : {}),
    ...(direction ? { direction } : {}),
  };
}

export const containersApi = {
  /**
   * Lista de containere în format claude-design (ContainerRow[]).
   * @param companyId când e setat, restricționează la firma respectivă.
   * @param direction import | export — direcția selectată în portal.
   */
  getContainers: async (
    companyId?: number,
    direction?: ShippingDirection,
  ): Promise<ContainerRow[]> => {
    const response = await http.get('/containers', { params: dataParams(companyId, direction) });
    return (response.data?.data as ContainerRow[]) ?? [];
  },

  getStatistics: async (
    companyId?: number,
    direction?: ShippingDirection,
  ): Promise<ContainerStatistics> => {
    const response = await http.get('/containers/statistics', {
      params: dataParams(companyId, direction),
    });
    return response.data.data;
  },

  getContainerDetails: async (
    id: number,
    direction?: ShippingDirection,
  ): Promise<ContainerDetailsModalData> => {
    const response = await http.get(`/containers/${id}/details`, {
      params: dataParams(undefined, direction),
    });
    return response.data.data;
  },

  /**
   * Date complete pentru modal-ul claude-design.
   */
  getModalData: async (
    id: number,
    companyId?: number,
    direction?: ShippingDirection,
  ): Promise<ContainerModalData> => {
    const response = await http.get(`/containers/${id}/modal`, {
      params: dataParams(companyId, direction),
    });
    return response.data.data;
  },

  async updateClientNote(id: number, clientNote: string): Promise<string | null> {
    const response = await http.patch(`/containers/${id}/client-note`, { clientNote });
    return (response.data?.data?.clientNote ?? null) as string | null;
  },
};
